var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-link',{staticClass:"gfm gfm-project_member js-user-link",class:{ 'current-user': _vm.isCurrentUser },attrs:{"data-reference-type":"user","data-original":`@${_vm.data.username}`,"href":_vm.data.webUrl,"title":_vm.data.name,"data-user":_vm.userId}},[_vm._v("@"+_vm._s(_vm.data.username))])
}
var staticRenderFns = []

export { render, staticRenderFns }